import React from "react";
import ReactApexChart  from "react-apexcharts";
import { formatAmount } from "../../../../../../../util/Helpers";

const CandleStickChart = ({data, currency}) => {

    const chartData = data.map(el => ({y: [
                                            el.open?.toFixed(2), 
                                            el.high?.toFixed(2), 
                                            el.low?.toFixed(2), 
                                            el.close?.toFixed(2)
                                        ], 
                                        x: new Date(el.date)}));

    const options = {
        series: [{
            data: chartData
        }],
        chart: {
            type: 'candlestick',
            height: 350,
            toolbar: {
                tools: {
                  download: false,
                  reset: false,
                  selection: false,
                  zoom: false
                }
            }
        },
        xaxis: {
            type: 'datetime'
        },
        yaxis: {
            tooltip: {
                enabled: true
            },
            labels: {
                formatter: value => formatAmount(currency, value)
            }
        },
        colors: ["#1BC5BD", "#F64E60"],
        tooltip: {
            x: {
              format: 'dd MMM yyyy'
            },
            custom: ({ seriesIndex, dataPointIndex, w }) => {
              const o = w.globals.seriesCandleO[seriesIndex][dataPointIndex]
              const h = w.globals.seriesCandleH[seriesIndex][dataPointIndex]
              const l = w.globals.seriesCandleL[seriesIndex][dataPointIndex]
              const c = w.globals.seriesCandleC[seriesIndex][dataPointIndex]
              return (
                        `<div class="apexcharts-tooltip-candlestick">
                        <div>Open: <span class="value">
                        ${formatAmount(currency, o)}
                        </span></div>
                        <div>High: <span class="value"> 
                        ${formatAmount(currency, h)}
                        </span></div>
                        <div>Low: <span class="value">
                        ${formatAmount(currency, l)}
                        </span></div>
                        <div>Close: <span class="value"> 
                        ${formatAmount(currency, c)}
                        </span></div>
                        </div>`
                    )
            }
          }
    };


    return <ReactApexChart options={options} series={options.series} type="candlestick"  height="500"/>

}

export default CandleStickChart;